import React from 'react'
import Lottie from 'react-lottie'

import { compose, defaultProps } from 'recompose'

import acornsLoader from './AcornsLoader.json'

type Props = {
  animationData?: JSON
}
const enhance = compose<any, Props>(
  defaultProps({
    options: {
      loop: false,
      autoplay: true,
      animationData: acornsLoader,
    },
    height: 100,
    width: 100,
  }),
)

export default enhance(({ options, height, width }) => (
  <Lottie options={options} width={width} height={height} />
))
